var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.13071 13.264L4.02417 10.1575C3.67502 9.80836 3.11101 9.80836 2.76186 10.1575C2.41271 10.5067 2.41271 11.0707 2.76186 11.4198L6.50403 15.162C6.85318 15.5111 7.41719 15.5111 7.76634 15.162L17.2381 5.69019C17.5873 5.34104 17.5873 4.77703 17.2381 4.42788C16.889 4.07873 16.325 4.07873 15.9758 4.42788L7.13071 13.264Z",
    fill: "#FBFBFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/Check.26de9d57a6a269d08707010c2791ed0f.svg";
export { ForwardRef as ReactComponent };